import { render, staticRenderFns } from "./ValuesEditorView.vue?vue&type=template&id=4bb7b74c&scoped=true&"
import script from "./ValuesEditorView.vue?vue&type=script&lang=js&"
export * from "./ValuesEditorView.vue?vue&type=script&lang=js&"
import style0 from "./ValuesEditorView.vue?vue&type=style&index=0&id=4bb7b74c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb7b74c",
  null
  
)

export default component.exports